'use strict';

/*
DOCUMENT ME
*/

define('modules/module',[
  'jquery',
  'Handlebars',
  'txt!./module.hbs',

  // side effect includes
  'lib/helpers/data-layer',
  'lib/helpers/math',
  'lib/helpers/ifCond',
  'lib/helpers/pluralize',
  'lib/helpers/data-attr',
  'lazyload'
], function (
  $,
  Handlebars,
  txtTemplate
) {
  var __baseTmpl = Handlebars.compile(txtTemplate);

  var Module = function (canvas, config, idx) {
    this._canvas = canvas;
    this._config = config;
    this.initialize(canvas, config, idx);
  };

  // Static size keys for when the context is formatted to send off to the template.
  // This also dictates the layout key search order with later keys override earlier keys
  // values
  var __layoutSizeKeys = ['1x1', '2x1', '3x1', 'fullx1'];

  // Some static properties
  Module.configurable = true;

  $.extend(Module.prototype, {
    // This structure is starting to look more and more like backbone... hmmmm
    tagName: 'div',
    className: 'module',
    // default event for all modules
    events: {
      'click .datalayer-link': 'decorateLink',
      'click .module-headline': 'headlineClick'
    },

    initialize: function (canvas, config, idx) {
      // Figure out what template we are using
      var self = this;
      var tmpl = __baseTmpl;
      var tokens;

      if (this.template) {
        tmpl = this.template;
      } else if (this.templateSelector) {
        tmpl = Handlebars.compile($(this.templateSelector).html());
      }
      this._tmpl = tmpl;

      // Create our element
      var $el = this.$el = $(document.createElement(this.tagName)).addClass(this.className);

      // Bind our events
      var events = this.events;
      if (typeof events === 'function') {
        events = events.call(this);
      }

      // Options. If selector is .module-cta-0, delegate to .module-headline as well
      $.each(Object.keys(events), function (idx, key) {
        tokens = key.split(' ');
        if (tokens.length == 1) {
          // Just a selector was given, assume click
          $el.on('click', key, self[events[key]].bind(self));
        } else {
          $el.on(tokens[0], tokens.slice(1).join(' '), self[events[key]].bind(self));
        }
      });
      this.moduleIdx = idx;
      // Don't worry about render yet, will be called in the first layout call
    },

    setTemplate: function (tmpl, silent) {
      if (typeof tmpl === 'string') {
        this._tmpl = Handlebars.compile(tmpl);
      } else {
        this._tmpl = tmpl;
      }

      !silent && this.render();
    },

    // This formats the context object from key: {1x1: ... 2x1: ..., 3x1: ... fullx1: ...}
    // to key: value based on the current layout, if a layout key isn't
    // available, it just copies the value
    formatTemplateContext: function (ctx, layout) {
      var result = {};

      var resp = [layout];
      var tokens = layout.split('x');
      var unitW = tokens[0];
      var i;
      var obj;
      var foundLayoutKey;
      var layoutKey;

      for (i = unitW === 'full' ? 3 : unitW - 1; i > 0; i--) {
        resp.push(i + 'x' + tokens[1]);
      }

      $.each(Object.keys(ctx), function (idx, key) {
        if (typeof ctx[key] === 'object') {
          foundLayoutKey = false;
          obj = ctx[key];

          for (i = 0; i < __layoutSizeKeys.length; i += 1) {
            layoutKey = __layoutSizeKeys[i];
            if (obj.hasOwnProperty(layoutKey)) {
              foundLayoutKey = true;

              if (resp.indexOf(layoutKey) >= 0) {
                result[key] = obj[layoutKey];
              }
            }
          }

          if (foundLayoutKey) return;

          // If we got here, no key matched, just assume the object
          // is expected in the context
          result[key] = obj;
        } else {
          result[key] = ctx[key];
        }
      });

      return result;
    },

    getTemplateContext: function () {
      return this._config.data || {};
    },

    getDataLayer: function () {
      var sizeMap = {
        '1x1': 'Small',
        '2x1': 'Medium',
        '3x1': 'Large',
        fullx1: 'Full'
      };
      var cfg = this.getConfig();
      var moduleId = [cfg.type.replace('.', '_').toLowerCase() + '_Module'];
      if (this.layout) {
        moduleId.push(sizeMap[this.activeLayout]);
      }
      return {
        content_section: moduleId.join('_'), // cfg.type, // BAT25-401.
        list_item_index: (this.moduleIdx + 1).toString(),
        link_module: moduleId.join('_')
      };
    },

    getConfig: function () { return this._config; },
    getCanvas: function () { return this._canvas; },

    calculateUnitSize: function (bk) {
      var cfg = this.getConfig();

      // In accordance of BAT25-109
      if (bk === 'lg') {
        return { width: cfg.width, height: cfg.height || 1 };
      }
      return { width: 1, height: cfg.height || 1 };
    },

    resize: function (bk, unitW, unitH) {
      // Give the module the opportunity to handle the change in size
      var layout = unitW + 'x' + unitH;

      // Save a reference to the current layout in case rendering happens again
      this.activeLayout = layout;

      // update our html
      this.render(layout);
    },

    // we have our sizes in here (this.$el is certain to be in DOM tree)
    layout: function () {
      // no-op
    },

    render: function (layout) {
      // Default the layout if one wasn't provided
      layout || (layout = this.activeLayout);

      // If we don't have a layout here, we haven't been sized and therefore never rendered before
      if (!layout) return;

      // Determine our class
      var cfg = this.getConfig();
      var classes = [this.className, 'module-' + layout, 'module-' + cfg.type.replace(/\./g, '-')];
      var ctx = this.formatTemplateContext(this.getTemplateContext(layout), layout);

      // Check for a moduleClassName in the context
      if (ctx.moduleClassName) {
        classes.push(ctx.moduleClassName);
      }

      // set some defaults on the context
      ctx.layout = layout;
      ctx.dataLayer = this.getDataLayer();

      this.$el.attr('class', classes.join(' '));
      this.$el.data('layer', ctx.dataLayer);
      this.$el.html(this._tmpl(ctx));
      this.onrender && this.onrender(this, layout, ctx);
      // setup any images for lazyload
      $('.lazy', this.$el).lazy();
    },

    decorateLink: function (e) {
      var $target = $(e.currentTarget);
      var $parent = $target.closest('.module');
      var data = $target.data('layer') || {};

      if (typeof data !== 'object') {
        data = JSON.parse(data);
      }
      // supplement target data with parent data
      if ($parent.length) {
        var parentData = $parent.data('layer');
        var fullData = Object.assign({}, parentData, data);
        $target.data('layer', fullData);
        e.currentTarget.setAttribute('data-layer', JSON.stringify(fullData));
      }
    },

    headlineClick: function (e) {
      var $cta = this.$el.find('.module-footer > .module-cta-0');
      if ($cta.length) {
        // mangle link_text
        $cta[0].setAttribute('data-layer', JSON.stringify({link_text: e.currentTarget.innerText}));
        $cta[0].click();
      }
    }
  });

  // Slightly modified version of Backbones extend which is more or less goog.inherits.
  // This is updated to leverage jQuery instead of underscore.
  Module.extend = function (protoProps, staticProps) {
    var parent = this;
    var child;

    // Figure out our constructor
    if (protoProps && protoProps.hasOwnProperty('constructor')) {
      child = protoProps.constructor;
    } else {
      child = function () { return parent.apply(this, arguments); };
    }

    // Add any statics
    $.extend(child, parent, staticProps);

    // Setup the proto chain
    child.prototype = $.extend({}, parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Store a reference in case
    child.__super__ = parent.prototype;

    return child;
  };

  return Module;
});

